const MAX_WIDTH = 1024;
const IMAGE_QUALITY = 0.75;

const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp'];

/**
 * Indica si el archivo es una imagen comprimible
 * @param {File} archivo
 * @return {boolean}
 */
function esImagen(archivo) {
  const extension = archivo.name.split('.').pop().toLowerCase();
  return IMAGE_EXTENSIONS.includes(extension);
}

/**
 * Comprime la imagen redimensionándola al ancho máximo y convirtiéndola a JPEG
 * @param {File} archivo
 * @return {Promise<File>}
 */
function comprimirImagen(archivo) {
  return new Promise((resolver, rechazar) => {
    const lector = new FileReader();
    lector.readAsDataURL(archivo);
    lector.onload = (evento) => {
      const imagen = new Image();
      imagen.src = evento.target.result;
      imagen.onload = () => {
        let width = imagen.width;
        let height = imagen.height;

        if (width > MAX_WIDTH) {
          height = Math.round((height * MAX_WIDTH) / width);
          width = MAX_WIDTH;
        }

        const lienzo = document.createElement('canvas');
        lienzo.width = width;
        lienzo.height = height;

        const contexto = lienzo.getContext('2d');
        contexto.drawImage(imagen, 0, 0, width, height);

        lienzo.toBlob((blob) => {
          const nombre = archivo.name.replace(/\.[^.]+$/, '.jpg');
          resolver(new File([blob], nombre, {type: 'image/jpeg'}));
        }, 'image/jpeg', IMAGE_QUALITY);
      };
      imagen.onerror = () => rechazar(new Error('Error al cargar la imagen'));
    };
    lector.onerror = () => rechazar(new Error('Error al leer el archivo'));
  });
}

export {
  esImagen,
  comprimirImagen,
};
